import React from 'react';
import { useBranding } from '../context/BrandingContext';
import { useTheme } from '../context/ThemeContext';

// Renders the configured platform logo (theme-aware) with a text fallback.
export const BrandLogo = ({ className = '', textClassName = 'text-xl', imgClassName = 'h-8 w-auto max-w-[160px]' }) => {
  const { branding, assetUrl } = useBranding();
  const { theme } = useTheme();

  const themed = theme === 'dark' ? branding.dark_logo_url : branding.light_logo_url;
  const logo = assetUrl(themed || branding.primary_logo_url);

  if (logo) {
    return (
      <img src={logo} alt={branding.brand_name || 'Logo'} className={`${imgClassName} ${className}`} data-testid="brand-logo-img" />
    );
  }

  const name = branding.brand_name || 'AwadhPay';
  // Accent a trailing "Pay" for the default brand; otherwise render plain.
  const m = /^(.*?)(pay)$/i.exec(name);
  return (
    <span className={`font-heading font-bold tracking-tight ${textClassName} ${className}`} data-testid="brand-logo-text">
      {m ? <>{m[1]}<span className="text-primary">{m[2]}</span></> : name}
    </span>
  );
};

export default BrandLogo;
